import SEOMeta from '../../components/SEOMeta';
import UrgencyBar from './components/UrgencyBar';
import Header from './components/Header';
import Hero from './components/Hero';
import HowItWorks from './components/HowItWorks';
import MusicalStyles from './components/MusicalStyles';
import Occasions from './components/Occasions';
import Testimonials from './components/Testimonials';
import Pricing from './components/Pricing';
import Guarantee from './components/Guarantee';
import FAQ from './components/FAQ';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Inspira Músicas',
  url: 'https://inspiramusicas.com.br',
  logo: 'https://inspiramusicas.com.br/logo-light.png',
  description: 'Músicas personalizadas como presente emocional. A partir de R$ 34,90, prontas em até 30 minutos.',
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Rua Pais Leme, 215, Conj. 1713, Sala 01',
    addressLocality: 'São Paulo',
    addressRegion: 'SP',
    postalCode: '05424-150',
    addressCountry: 'BR',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    contactType: 'customer service',
    availableLanguage: 'Portuguese',
  },
};

export default function Home() {
  return (
    <div className="home-shell-bg" style={{ fontFamily: "'DM Sans', sans-serif" }}>
      <SEOMeta
        title="Músicas Personalizadas para Quem Você Ama | Inspira Músicas"
        description="Crie uma música exclusiva para homenagear quem você ama. Sertanejo, MPB, Gospel e mais de 25 estilos. A partir de R$ 34,90, pronta em até 30 minutos."
        path="/"
        jsonLd={organizationSchema}
      />
      {/* Sticky top wrapper */}
      <div className="sticky top-0 z-50">
        <UrgencyBar />
        <Header />
      </div>

      <main style={{ background: 'transparent' }}>
        <Hero />
        <div className="home-flow-bg">
          <HowItWorks />
          <MusicalStyles />
          <Occasions />
          <Testimonials />
          <Pricing />
          <Guarantee />
          <FAQ />
        </div>
        <FinalCTA />
      </main>

      <Footer />
    </div>
  );
}
